import useTheme from "@material-ui/core/styles/useTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery";

export default function useDesktopSize() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up("md"));
}
